// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1x2in","col":"Table_col__2l6D3","fulfillmentStatus":"Table_fulfillmentStatus__2mDEZ","emailCol":"Table_emailCol__19MZA"};